// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__912qo","notes":"Notes_notes__1x0F1","note":"Notes_note__2J44G","markdown":"Notes_markdown__eVKTy"};